define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ServiceError = exports.ServiceErrorLevel = void 0;
    var ServiceErrorLevel;
    (function (ServiceErrorLevel) {
        ServiceErrorLevel[ServiceErrorLevel["Error"] = 0] = "Error";
        ServiceErrorLevel[ServiceErrorLevel["Warning"] = 1] = "Warning";
        ServiceErrorLevel[ServiceErrorLevel["Info"] = 2] = "Info";
    })(ServiceErrorLevel || (exports.ServiceErrorLevel = ServiceErrorLevel = {}));
    class ServiceError extends Error {
        constructor(msg) {
            super(msg);
            Object.defineProperty(this, "Level", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Response", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Message", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Service", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Method", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Code", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Inputs", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StackTrace", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.Level = ServiceErrorLevel.Error;
            this.Message = msg;
            Object.setPrototypeOf(this, ServiceError.prototype);
        }
        static fromError(err) {
            const e = new ServiceError(err.message);
            e.Method = err.name;
            e.StackTrace = err.stack;
            return e;
        }
    }
    exports.ServiceError = ServiceError;
});
